export default "__VITE_ASSET__$Jddcqfr__"